export class Translation {
    public getTranslationLanguage(local: string): string {
        if (local !== undefined) {
            const language = local.split('-')[0];
            return ['de', 'fr', 'en', 'it', 'nl'].includes(language) ? language : 'de';
        }
        return 'de';
    }
}
